import react from "react";
import { useState, useEffect } from "react";
import ModalForm from "./ModalForm";

function ModalMensaje(props) {

    const [modalState, setModalState] = useState(props.estadoInicial);

    //const cerrar = () => {
    function cerrar() {
        if (props.accion!=null) {
            props.accion();
        }
        //props.accion();
        setModalState('hidden');
    }

    useEffect(() => {

    },[]);
    
    return <div className={'sm-modal-container '+modalState}>
                <div className="sm-modal">
                    <span className="sm-modal-msg">
                        {props.mensaje}
                    </span>
                    <button className="btn btn-success" onClick={cerrar}>
                        Aceptar
                    </button>
                </div>
            </div>
}
export default ModalMensaje;